import { WORKSPACE_SWITCH_FALLBACK_PROFILE_PATH } from "./routeSafetyMap";

/**
 * Landing page after switching to another project (L'Tax → L'EPR → L'Authorize ...).
 * Project route maps render their own Dashboard at "/", and not every project has the
 * page the user came from, so a project switch always opens the settings hub.
 */
export const PROJECT_SWITCH_LANDING_PATH = WORKSPACE_SWITCH_FALLBACK_PROFILE_PATH;

/** Append the landing path to a project base URL (e.g. https://authorize.dev.lappa.org/). */
export function buildProjectSwitchUrl(baseUrl) {
  const base = String(baseUrl ?? "").trim();
  if (!base) {
    return PROJECT_SWITCH_LANDING_PATH;
  }

  const [withoutHash] = base.split("#");
  const [pathPart, queryPart] = withoutHash.split("?");
  const normalizedBase = pathPart.replace(/\/+$/, "");
  const target = `${normalizedBase}${PROJECT_SWITCH_LANDING_PATH}`;

  return queryPart ? `${target}?${queryPart}` : target;
}
